var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-progress"},[_c('div',{staticClass:"stat-value",style:({ width: `${_vm.widthPercent || 0}%` })})]),(!_vm.hideTitle)?_c('div',{staticClass:"stat-title"},[_vm._t("title",function(){return [_c('span',[_vm._v(_vm._s(_vm.title))])]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }